import { render, staticRenderFns } from "./AlertContainer.vue?vue&type=template&id=2f7a340e&scoped=true"
import script from "./AlertContainer.vue?vue&type=script&lang=js"
export * from "./AlertContainer.vue?vue&type=script&lang=js"
import style0 from "./AlertContainer.vue?vue&type=style&index=0&id=2f7a340e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a340e",
  null
  
)

export default component.exports